import { render } from "./PostReviewerAttribute.vue?vue&type=template&id=5d9cee7d&ts=true"
import script from "./PostReviewerAttribute.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostReviewerAttribute.vue?vue&type=script&lang=ts&setup=true"

import "./PostReviewerAttribute.vue?vue&type=style&index=0&id=5d9cee7d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostReviewerAttribute.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d9cee7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d9cee7d', __exports__)) {
    api.reload('5d9cee7d', __exports__)
  }
  
  module.hot.accept("./PostReviewerAttribute.vue?vue&type=template&id=5d9cee7d&ts=true", () => {
    api.rerender('5d9cee7d', render)
  })

}


export default __exports__